/**
 * Compare two arrays of objects by value
 * @param {Object} array1 - The first array to compare
 * @param {Object} array2 - The second array to compare
 * @param {string} sortingKey - The key to sort the objects by
 * @returns {boolean} - True if the arrays are equal, false otherwise
 */
const compareArraysOfObjects = (array1, array2, sortingKey) => {
    // Checking if the arrays have the same length
    if (array1.length !== array2.length) {
        return false;
    }

    // Sorting the arrays by the sorting key
    const sorted1 = [...array1].sort((a, b) => a[sortingKey].localeCompare(b[sortingKey]));
    const sorted2 = [...array2].sort((a, b) => a[sortingKey].localeCompare(b[sortingKey]));

    // Comparing the arrays by the sorting key and the value
    return sorted1.every((object, index) =>
        object[sortingKey] === sorted2[index][sortingKey] &&
        JSON.stringify(object.value) === JSON.stringify(sorted2[index].value)
    );
};

export default compareArraysOfObjects;